import { render, staticRenderFns } from "./SoccerGameTimeline.vue?vue&type=template&id=705cd934&scoped=true&"
import script from "./SoccerGameTimeline.vue?vue&type=script&lang=ts&"
export * from "./SoccerGameTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./SoccerGameTimeline.vue?vue&type=style&index=0&id=705cd934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705cd934",
  null
  
)

export default component.exports